import { PROSPECT_STATUS } from "../../constants/config";

export const StatusBadge = ({ status, size = "sm" }) => {
  const s = PROSPECT_STATUS[status] || PROSPECT_STATUS.prospek;
  const sizes = {
    xs: "text-[10px] px-1.5 py-0.5",
    sm: "text-[11px] px-2 py-0.5",
    md: "text-xs px-2.5 py-1",
  };
  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold ${sizes[size]}`}
      style={{ color: s.color, backgroundColor: s.bg }}
      data-testid={`status-badge-${status}`}
    >
      <span
        className="w-1.5 h-1.5 rounded-full mr-1.5"
        style={{ backgroundColor: s.color }}
      />
      {s.label}
    </span>
  );
};
